"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstLoan = void 0;
var Joi = require('joi').extend(require('@joi/date'));
exports.firstLoan = Joi.object({
    currentAmortizationPeriodYears: Joi.number()
        .min(0)
        .max(40)
        .required()
        .options({ convert: false }),
    currentAmortizationPeriodMonths: Joi.number()
        .min(0)
        .max(11)
        .required()
        .options({ convert: false }),
    currentAmortizationPeriod: Joi.string()
        .min(0)
        .max(4)
        .required(),
    currentArrears: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .required(),
    interestRate: Joi.number()
        .min(0)
        .max(99999.9999)
        .precision(4)
        .options({ convert: false })
        .required(),
    nextRenewalDate: Joi.date()
        .max('12-31-9999')
        .required(),
    occupancyType: Joi.string()
        .min(0)
        .max(500)
        .empty('')
        .required(),
    originalAmortizationPeriodYears: Joi.number()
        .min(0)
        .max(40)
        .allow('')
        .optional()
        .options({ convert: false }),
    originalAmortizationPeriodMonths: Joi.number()
        .min(0)
        .max(11)
        .allow('')
        .optional()
        .options({ convert: false }),
    originalAmortizationPeriod: Joi.string()
        .min(0)
        .max(4)
        .allow('')
        .optional(),
    rankingPriority: Joi.string()
        .min(0)
        .max(10)
        .empty('')
        .required(),
    registeredMortgageHolder: Joi.string()
        .min(0)
        .max(30)
        .allow('')
        .optional(),
    requiredMonthlyPaymentPrincipalInterest: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .required(),
    unpaidBalance: Joi.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .required(),
});
exports.default = { firstLoan: exports.firstLoan };
